<template>
  <div id="calendar-container">
    <div class="calendar-parent pt-5 pb-5">
      <calendar-view
        style="	width: 90%; margin-left: 5%;"
        :events="currentEvents"
        :show-date="showDate"
        :time-format-options="{ hour: 'numeric', minute: '2-digit' }"
        :disable-past="disablePast"
        :disable-future="disableFuture"
        :show-event-times="showEventTimes"
        :display-period-uom="displayPeriodUom"
        :display-period-count="displayPeriodCount"
        :starting-day-of-week="startingDayOfWeek"
        :class="themeClasses"
        :current-period-label="useTodayIcons ? 'icons' : ''"
        @click-event="onEventClick"
      >
        <div
          slot="header"
          slot-scope="{ headerProps }"
          class="cv-header p-3 border"
        >
          <div class="cv-header-nav border m-0">
            <button type="button" :disabled="headerProps.previousPeriod === null" class="btn" @click="setShowDate(headerProps.previousPeriod)">Previous</button>
            <button type="button" class="btn" style="color: black;" disabled>{{ currentMonth }} {{ currentYear }}</button>
            <button type="button" class="btn" @click="setShowDate(headerProps.nextPeriod)">Next</button>
          </div>
        </div>
      </calendar-view>
      <Modal :calendar="calendar" :submitSuccess="bookSuccess" :submitError="bookError" :slotData="currentSlot" modalId="calendar-modal" v-if="modalOpen" @bookSlot="handleBookSlot" @close="modalOpen = false" />
    </div>
  </div>
</template>
<script>
// Load CSS from the published version
require("vue-simple-calendar/static/css/default.css")
require("vue-simple-calendar/static/css/holidays-us.css")

import Modal from './Modal.vue'
import {
	CalendarView,
	CalendarMathMixin,
} from "vue-simple-calendar" // published version

import { getInterviewSlotsMonths, bookSlot } from '../../services/api'
import {  mapGetters } from 'vuex'

import moment from 'moment'
export default {
	name: "App",
	components: {
		CalendarView,
    Modal
	},
	mixins: [CalendarMathMixin],
	data() {
		return {
			monthNames: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
			showDate: this.thisMonth(1),
			message: "",
			startingDayOfWeek: 0,
			disablePast: true,
			disableFuture: false,
			displayPeriodUom: "month",
			displayPeriodCount: 1,
			showEventTimes: false,
			newItemTitle: "",
			newItemStartDate: "",
			newItemEndDate: "",
			useDefaultTheme: true,
			useHolidayTheme: true,
			useTodayIcons: false,
      events: [],
      queryMonth: {
        month: '',
        year: ''
      },
      modalOpen: false,
      currentSlot: '',
      bookSuccess: false,
      bookError: false,
      error: false,
		}
	},
  props: {
    calendar: {
        type: String,
        required: true
    }
  },
	computed: {
    ...mapGetters({
      getToken: 'authStore/getToken',
      getRecruit: 'authStore/getRecruit'
    }),
    currentMonth() {
      return this.monthNames[`${this.showDate.getMonth()}`]
    },
    currentYear() {
      return this.showDate.getFullYear()
    },
    currentEvents() {
      return this.events
    },
		userLocale() {
			return this.getDefaultBrowserLocale
		},
		dayNames() {
			return this.getFormattedWeekdayNames(this.userLocale, "long", 0)
		},
		themeClasses() {
			return {
				"theme-default": this.useDefaultTheme,
			}
		},
	},
	mounted() {
		this.newItemStartDate = this.isoYearMonthDay(this.today())
		this.newItemEndDate = this.isoYearMonthDay(this.today())
    const dt = new Date()
    const month = dt.getMonth() + 1
    const year = dt.getFullYear()
    this.getCalendarData(month, year)
	},

	methods: {
    async getCalendarData (month, year) {
      // Reset events array each time function is called
      this.events = []
      let today = new Date()
      // Get month and year
      this.queryMonth.month = month
      this.queryMonth.year = year
      const res = await getInterviewSlotsMonths(this.queryMonth)
      if (res) {
        const days = res.data.slots
        let slotId = 0
        days.forEach(day => {
          let dayDate = new Date(`${year}`,`${month - 1}`,`${day.day}`)
          const event = {
            type: this.calendar,
            startDate: moment([year, month - 1, day.day, 0, 0]).format('YYYY-MM-DD HH:mm'),
            endDate: moment([year, month - 1, day.day, 23, 59]).format('YYYY-MM-DD HH:mm'),
            id: ++slotId,
            class: this.calendar === 'f2f' ? 'face-to-face' : 'phone-interview',
            title: `${ this.calendar === 'f2f' ? day.f2fFree : day.phoneFree } ${day.f2fFree > 1 || day.phoneFree > 1 ? 'slots' : 'slot'} ${this.calendar === 'f2f' ? 'for' : ''} ${day.branch}`
          }
          if (this.calendar === 'phone' && day.phoneFree > 0 && dayDate >= today) {
            this.events.push(event) 
          }

          if (this.calendar === 'f2f' && day.f2fFree > 0 && dayDate >= today) {
            // Check branches available branch slots against users chosen branches
            const branch = day.branch
            if (this.getRecruit.centres.includes(branch)) {
              this.events.push(event)
            }
          }
        })
      } else {
       this.error = true
      }
    },
		thisMonth(d, h, m) {
			const t = new Date()
			return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0)
		},
    onEventClick (e) {
      this.currentSlot = e
      this.modalOpen = !this.modalOpen
    },
		setShowDate(d) {
			this.showDate = d
      const dt = new Date(d)
      const month = dt.getMonth() + 1
      const year = dt.getFullYear()
      this.getCalendarData(month, year)
		},
    async handleBookSlot (id) {
      const res = await bookSlot(this.getToken, id)
      if (res) {
        this.bookError = false
        this.bookSuccess = true
        localStorage.clear()
        setTimeout(() => {
          this.$router.push('/holding')
        }, 8000)
      } else {
        this.bookSuccess = false
        this.bookError = true
      }
    },
	},
}
</script>

<style>
html,
body {
	height: 100%;
	margin: 0;
	background-color: #f7fcff;
}

#calendar-container {
	font-family: Calibri, sans-serif;

}
.cv-header {
    display: flex;
    flex-direction: column-reverse !important;
}

.calendar-parent {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	overflow-x: hidden;
	overflow-y: hidden;
	max-height: 80vh;
  background-color: #f0f0f0;
}

.theme-default .cv-event {
    border-color: lightgreen;
    border-radius: 0.5em;
    background-color: lightgreen;
    text-overflow: ellipsis;
    cursor: pointer;
}

.theme-default .cv-event:hover {
  font-weight: bold;
}
.nextPeriod:hover {
    font-weight: 400;
}

.cv-week {
    flex-flow: row nowrap;
    min-height: 5rem !important;
    border-width: 0;
    position: relative;
    width: 100%;
}
/* For long calendars, ensure each week gets sufficient height. The body of the calendar will scroll if needed */
.cv-wrapper.period-month.periodCount-2 .cv-week,
.cv-wrapper.period-month.periodCount-3 .cv-week,
.cv-wrapper.period-year .cv-week {
	min-height: 6rem;
}



</style>
